export default "__VITE_ASSET__DTJ3s8HI__"